import { useEffect, useState } from 'react';

import { formatCallDuration, secondsSince } from '../../utils/call-status-meta';

interface CallTimerProps {
    /** ISO timestamp the call was answered — timer freezes at 00:00 while null. */
    readonly answeredAt: string | null;
    readonly className?: string;
}

/**
 * `mm:ss` elapsed-time display. The elapsed value is DERIVED at render from
 * `answeredAt` — the interval only forces the re-render. Holding it in state
 * instead meant a changed anchor (the optimistic local stamp being replaced by
 * the authoritative server one within a single mount) kept displaying the old
 * value until the next tick.
 */
export function CallTimer({ answeredAt, className }: CallTimerProps) {
    const [, setTick] = useState(0);

    useEffect(() => {
        if (!answeredAt) return;
        const interval = setInterval(() => setTick((t) => t + 1), 1000);
        return () => clearInterval(interval);
    }, [answeredAt]);

    const elapsed = answeredAt ? secondsSince(answeredAt) : 0;

    return <span className={className}>{formatCallDuration(elapsed)}</span>;
}
